import styled from 'styled-components';

import share_background from '../../../assests/images/bg.png';

export const NonprofitLeft = styled.div`
    max-width: 894px;
    width: 100%;
`;
export const NonprofitRight = styled.div`
    max-width: 282px; 
    width: 100%;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }
`;

export const OverviewWrapper = styled.div`
    display:flex; 
    gap: 24px;
 @media screen and (max-width:991px) {
     flex-wrap: wrap;
 }
    @media screen and (max-width:767px) {
        flex-direction: column
    }  
`;
export const BrowseSearch = styled.div`
  
`;

export const CommunityStories = styled.div`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 10px;
    color: #FFFFFF;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight:700;
    line-height: 43px;
    padding:9px 23px;
    margin-top: 50px;
  
    @media screen and (max-width:575px) {
        font-size: 25px;
        line-height: 40px;
        margin-bottom: 20px;
    }
`;

export const StoriesTitle = styled.div`
     display: flex;
    justify-content: space-between;
    margin: 20px 0;
    align-items: center;

    @media screen and (max-width:575px) {
        flex-wrap: wrap;
        gap: 20px;
    }
    .dropdown-menu.show{
       
        transform: translate(-121px, 50px) !important;

        @media screen and (max-width:1440px) {
            transform: translate(0, 50px) !important;
        }
    }
`;

// OverviewWrapper,

export const TiTle = styled.h3`
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight:500;
    line-height: 26px;
    color: #000000;
    margin-bottom: 0;
`;

export const CommunityStoryWrapper = styled.div`
    &.community-story-wrapper{ 
        column-count: 2;
        counter-reset: item-counter;
          padding-bottom: 30px;
        @media screen and (max-width: 575px){
            column-count: 1;
        }
p{
      word-break: break-all;
}
    }
`;

export const CommunityClient = styled.div`
    display: flex;
    gap: 24px;
`;

export const ShareExperiences = styled.div`
    width: 100%;
    max-width: 435px;
    break-inside: avoid;
    
    @media screen and (max-width: 575px){
        max-width: 100%;
    }
`;

export const ClientReview = styled.div`
    width: 100%;
    max-width: 435px;
`;

export const ClientExperiences = styled.div`
    background: #333333 0% 0% no-repeat padding-box;
    border-radius: 15px;
    max-width:435px;
    width:100%;
    background-image:url(${share_background });
    background-position: right;
    padding: 60px 20px 60px 20px;
    margin-bottom: 24px;

    @media screen and (max-width: 575px){
        max-width: 100%;
    }
`;

export const ExTile = styled.h4`
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight:400;
    line-height: 24px;
    color: #FFFFFF;
    width: 100%;
    max-width: 161px;
    margin-bottom: 16px;
    margin-top: 5px;
`;

export const DonationWrapper = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 15px;
    padding:15px;
    margin-top:20px;
`;

export const ClientMessage = styled.div`
    background: #EFEFEF 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding:15px 15px 18px 15px;
    .donate-now-btn{
        width:100%;
    }
`;

export const Content = styled.p`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight:400;
    line-height: 21px;
    margin-top:10px;
    margin-bottom:12px;
    word-break: break-word;
`;

export const ClientLabel = styled.div`
    color: #000000; 
    font-size: 16px;
    line-height: 21px;
    font-family: "Jost", sans-serif;
    span{
        font-weight:300;
    }
`;

export const  DonateImageCol = styled.div`
  width:168px;
  min-width:168px;
  height:168px;
  margin:0 auto 15px auto;
  img{
    display:block;
    margin:0 auto;
  }
`;

export const SocialList = styled.ul`
    display: flex;
    padding: 0;
    list-style: none;
    gap: 10px;
    margin: 15px 0 20px 0;
    justify-content: center;
`;

export const SocialItem = styled.li`
       
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        
    a{
        display: flex;
        width: 36px;
        height: 36px;
        align-items: center;
        justify-content: center;
       
    } 
    &:first-child {
        background: #F7931E;
    } 
    &:nth-child(2){
        background: #4267B2;
    }
    &:nth-child(3){
        background: #000000;
    }
      
`;

export const PromoteNonprofit = styled.div`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding:20px;
    text-align: center;
    margin-top:20px;
   .write-yellow-btn{
        background:#FFD495;
        padding: 11px 22px;
     &:hover{
        background:#FFFFFF;
        color:#333333;
     }  
     &:active{
        background:#FFFFFF;
        color:#333333;
     }  
   }
`;

export const PromoteTiTle = styled.h3`
    color: #FFFFFF;
    font-size: 20px;
    line-height: 29px;
    font-family: "Jost", sans-serif;
    font-weight:700;
    margin-bottom:10px;
    margin-top:10px;
`;

export const PromoteText = styled.p`
    color: #FFFFFF;
    font-size: 14px;
    line-height: 21px;
    font-family: "Jost", sans-serif;
    font-weight:300;
`;

export const CommunityStoryDetails = styled.div`
    display: flex;
    flex-wrap: wrap;
    column-gap: 30px;
   button.btn.btn-primary{
    background-color: #33a7ae !important;
    border:none;
  margin-top: 15px;
}
   img{
       width:100%;
       max-width: 67px;
      margin-top: 0px;
   }
`;